module.exports = __webpack_public_path__ + "static/media/sponsor_brighthair.53d8245f.webp";